import { HostSection } from './HostSection';
import { OtherSection } from './OtherSection';
import { TimeWindowSection } from './TimeWindowSection';

/**
 * Docker Setup Policy form fields.
 * Pure field renderer without FormActions - used by both create and edit modes.
 */
export function DockerSetupFormFields() {
  return (
    <>
      <HostSection />
      <OtherSection />
      <TimeWindowSection />
    </>
  );
}
